
 const HEADER_DATA = {
        "top_header": [
      {
        "name": "ENTREPRISE",
        "className": "",
        "link": "business",
        "child": []
      },
      {
        "name": "BROADBAND",
        "className": "",
        "link": "hbb",
        "child": []
      },
     
      {
        "name": "PORTAIL DÉVELOPPEUR",
        "className": "",
        "link": "https://developers.airtel.africa/",
        "child": []
      },
      {
        "name": "A PROPOS DE NOUS",
        "className": "",
        "link": "home/aboutus",
        "child": []
      },
      {
        "name": "CAREER",
        "className": "",
        "link": "career",
        "child": []
      }
    ],
    "main_header": [
        {
          "id": "mega-menu-pay",
          "name": "PAYEZ ET RECHARGEZ",
          "className": "",
          "megaMenuName": "pay",
          "link": "",
          "child": [
            {
              "name": "Postpayé",
              "className": "",
              "megaMenuName": "",
              "link": "",
              "child": [
                {
                  "name": "Paiement de facture en ligne",
                  "className": "",
                  "megaMenuName": "",
                  "link": "orp/postpaid",
                  "child": [],
                  "target":"_blank"
                }
              ]
            },
            {
              "name": "Prépayé",
              "className": "",
              "megaMenuName": "",
              "link": "",
              "child": [
                {
                  "name": "Rechargez un compte prépayé",
                  "className": "",
                  "megaMenuName": "",
                  "link": "orp/prepaid",
                  "child": [],
                  "target":"_blank"
                },
                {
                  "name": "Activez un forfait Internet",
                  "className": "",
                  "megaMenuName": "",
                  "link": "orp/data_bundle",
                  "child": [],
                  "target":"_blank"
                }
              ]
            }
          ]
        },
        {
          "id": "mega-menu-get",
          "name": "Product",
          "className": "",
          "megaMenuName": "get",
          "link": "",
          "child": [
            {
              "id": "",
              "name": "Prépayé",
              "className": "",
              "megaMenuName": "",
              "link": "",
              "child": [
                {
                  "id": "",
                  "name": "Appels et SMS Local",
                  "className": "",
                  "megaMenuName": "",
                  "link": "",
                  "child": [
                    {
                      "id": "",
                      "name": "Bonus à la recharge",
                      "className": "",
                      "megaMenuName": "",
                      "link": "bonusonrecharge",
                      "child": []
                    },
                    {
                      "id": "",
                      "name": "Forfaits Voix et Combo",
                      "className": "",
                      "megaMenuName": "",
                      "link": "prepaid/voice_combo",
                      "child": []
                    },
                    {
                      "id": "",
                      "name": "Forfaits SMS",
                      "className": "",
                      "megaMenuName": "",
                      "link": "prepaid/smsbundle",
                      "child": []
                    }
                  ]
                },
                {
                  "id": "",
                  "name": "International et Roaming",
                  "className": "",
                  "megaMenuName": "",
                  "link": "",
                  "child": [
                    {
                      "id": "",
                      "name": "Tarifs d'appels à l'international",
                      "className": "",
                      "megaMenuName": "",
                      "link": "prepaid/international/bundle",
                      "child": []
                    },
                    {
                      "id": "",
                      "name": "Forfaits à l'international",
                      "className": "",
                      "megaMenuName": "",
                      "link": "maxi_monde",
                      "child": []
                    },
                    {
                      "id": "",
                      "name": "Roaming Prépayé",
                      "className": "",
                      "megaMenuName": "",
                      "link": "prepaid/roamingover_view",
                      "child": []
                    },
                    {
                      "id": "",
                      "name": "Forfaits Roaming",
                      "className": "",
                      "megaMenuName": "",
                      "link": "forfaits_roaming",
                      "child": []
                    },
                    {
                      "id": "",
                      "name": "Free Roaming",
                      "className": "",
                      "megaMenuName": "",
                      "link": "free-roaming",
                      "child": []
                    },
                    {
                      "id": "",
                      "name": "One Airtel",
                      "className": "",
                      "megaMenuName": "",
                      "link": "post_one_airtel",
                      "child": []
                    },
                    {
                      "id": "",
                      "name": "Partenaires et Destinations",
                      "className": "",
                      "megaMenuName": "",
                      "link": "prepaid/partners_and_destinations",
                      "child": []
                    },
                    {
                      "id": "",
                      "name": "FAQs",
                      "className": "",
                      "megaMenuName": "",
                      "link": "postpaid/faqs",
                      "child": []
                    }
                  ]
                },
                {
                  "id": "",
                  "name": "Internet",
                  "className": "",
                  "megaMenuName": "",
                  "link": "",
                  "child": [
                    {
                      "id": "",
                      "name": "Service Internet",
                      "className": "",
                      "megaMenuName": "",
                      "link": "prepaid/service_internet",
                      "child": []
                    }
                  ]
                },
                {
                  "id": "",
                  "name": "Appareils",
                  "className": "",
                  "megaMenuName": "",
                  "link": "",
                  "child": [
                    {
                      "id": "",
                      "name": "4G Pocket WiFi",
                      "className": "",
                      "megaMenuName": "",
                      "link": "4g_pocket_wifi",
                      "child": []
                    },
                    {
                      "id": "",
                      "name": "4G Smartbox",
                      "className": "",
                      "megaMenuName": "",
                      "link": "4g_Smartbox",
                      "child": []
                    }
                  ]
                },
                {
                  "id": "",
                  "name": "Services à Valeur ajoutés",
                  "className": "",
                  "megaMenuName": "",
                  "link": "valueaddedservices",
                  "child": []
                },
                {
                  "id": "",
                  "name": "Airtel TV",
                  "className": "",
                  "megaMenuName": "",
                  "link": "airteltv",
                  "child": []
                }
              ]
            },
            {
              "id": "",
              "name": "Postpayé",
              "className": "",
              "megaMenuName": "",
              "link": "",
              "child": [
                {
                  "id": "",
                  "name": "Appels à l'international",
                  "className": "",
                  "megaMenuName": "",
                  "link": "",
                  "child": [
                    {
                      "id": "",
                      "name": "Tarifs Internationaux Postpayés",
                      "className": "",
                      "megaMenuName": "",
                      "link": "postpaid/internation/bundle",
                      "child": []
                    }
                  ]
                },
                {
                  "id": "",
                  "name": "Roaming",
                  "className": "",
                  "megaMenuName": "",
                  "link": "",
                  "child": [
                    {
                      "id": "",
                      "name": "Roaming Postpayé",
                      "className": "",
                      "megaMenuName": "",
                      "link": "postpaid/roamingover_view",
                      "child": []
                    },
                    {
                      "id": "",
                      "name": "Partenaires et destinations",
                      "className": "",
                      "megaMenuName": "",
                      "link": "postpaid/partners_and_destinations",
                      "child": []
                    },
                    {
                      "id": "",
                      "name": "One Airtel",
                      "className": "",
                      "megaMenuName": "",
                      "link": "post_one_airtel",
                      "child": []
                    },
                    {
                      "id": "",
                      "name": "FAQs Roaming",
                      "className": "",
                      "megaMenuName": "",
                      "link": "postpaid/faqs",
                      "child": []
                    }
                  ]
                },
                {
                  "id": "",
                  "name": "Credit Limit",
                  "className": "",
                  "megaMenuName": "",
                  "link": "",
                  "child": [
                    {
                      "id": "",
                      "name": "Présentation",
                      "className": "",
                      "megaMenuName": "",
                      "link": "postpaid/icontrol_services/overview",
                      "child": []
                    },
                    {
                      "id": "",
                      "name": "Avantages",
                      "className": "",
                      "megaMenuName": "",
                      "link": "postpaid/icontrol_services/advantag",
                      "child": []
                    },
                    {
                      "id": "",
                      "name": "FAQs",
                      "className": "",
                      "megaMenuName": "",
                      "link": "postpaid/icontrol_services/faqs",
                      "child": []
                    }
                  ]
                },
                {
                  "id": "",
                  "name": "Docs",
                  "className": "",
                  "megaMenuName": "",
                  "link": "docs",
                  "child": []
                }
              ]
            }
          ]
        },
        {
          "id": "",
          "name": "AIRTEL MONEY",
          "className": "",
          "megaMenuName": "",
          "link": "airtel_money",
          "child": []
        },
        {
          "id": "mega-menu-bank",
          "name": "NOS AGENCES",
          "className": "",
          "megaMenuName": "bank",
          "link": "",
          "child": [
            {
              "name": "Agences Airtel",
              "className": "",
              "megaMenuName": "",
              "link": "store_finder/airtel_shop",
              "child": []
            },
            {
              "name": "Vérifier la couverture",
              "className": "",
              "megaMenuName": "",
              "link": "store_finder/coverage",
              "child": []
            }
          ]
        },
        {
          "id": "",
          "name": "BESOIN D'AIDE",
          "className": "",
          "megaMenuName": "",
          "link": "gethelp",
          "child": []
        },
        {
          "id": "",
          "name": "BOX 4G",
          "className": "",
          "megaMenuName": "",
          "link": "Nos-Box-4G",
          "child": []
        },
        {
          "id": "",
          "name": "UNICEF",
          "className": "",
          "megaMenuName": "",
          "link": "unicef",
          "child": []
        }
      ]
     

}

export default HEADER_DATA;